import { Apple, Play } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "./ui/tooltip";

function Badge({ icon: Icon, top, bottom, comingSoon, url, testId }) {
  const content = (
    <div
      data-testid={testId}
      className={`group flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-2.5 transition-transform duration-300 hover:-translate-y-0.5 ${
        comingSoon ? "opacity-90" : ""
      }`}
    >
      <Icon className="h-6 w-6 text-foreground" />
      <div className="text-left leading-tight">
        <div className="text-[10px] uppercase tracking-wide text-muted-foreground">{top}</div>
        <div className="text-sm font-semibold text-foreground">{bottom}</div>
      </div>
      {comingSoon && (
        <span className="ml-1 rounded-full bg-gold/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gold">
          Soon
        </span>
      )}
    </div>
  );

  if (comingSoon) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="cursor-default">{content}</div>
        </TooltipTrigger>
        <TooltipContent>Coming soon</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  );
}

export function AppStoreBadges({ stores }) {
  return (
    <div className="flex flex-wrap gap-3">
      <Badge
        icon={Apple}
        top="Coming soon on the"
        bottom="App Store"
        comingSoon={stores?.appStore?.status === "coming-soon"}
        url={stores?.appStore?.url}
        testId="badge-app-store"
      />
      <Badge
        icon={Play}
        top="Coming soon on"
        bottom="Google Play"
        comingSoon={stores?.googlePlay?.status === "coming-soon"}
        url={stores?.googlePlay?.url}
        testId="badge-google-play"
      />
    </div>
  );
}
